import React from "react";
import FeaturesSplit from "../components/sections/FeaturesSplit";
import '../App.css'

function Projects() {
  return (
    <div className="fade-in">
      <FeaturesSplit
        invertMobile
        topDivider
        imageFill
        className="illustration-section-02"
      />
    </div>
  );
}

export default Projects;
